export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  EMAIL_CAMPAIGNS: 'email_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_ADVANCED_MANAGEMENT: 'captain_integration_v2',
  CAPTAIN_ADVANCED_APPROVALS: 'captain_agent_runtime_v3',
  CAPTAIN_TASKS: 'captain_tasks',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  INCOGNIA_RISK: 'incognia_risk',
  HOTJAR: 'hotjar',
  INTERCOM: 'intercom',
  INSTANA_RUM: 'instana_rum',
  OFFER_STATUS_LIST: 'offer_status_list',
};

// Advanced Captain capabilities grant access to the Captain workspace without
// replacing the original Captain entitlement. Keep the access aliases together
// so every entry point applies the same any-of rule.
export const CAPTAIN_ACCESS_FEATURE_FLAGS = [
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_ADVANCED_MANAGEMENT,
  FEATURE_FLAGS.CAPTAIN_ADVANCED_APPROVALS,
];

export const CAPTAIN_ADDITIONAL_FEATURE_FLAGS = [
  FEATURE_FLAGS.CAPTAIN_ADVANCED_MANAGEMENT,
  FEATURE_FLAGS.CAPTAIN_ADVANCED_APPROVALS,
];

export const CAPTAIN_TOOLS_FEATURE_FLAGS = [
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CAPTAIN_ADVANCED_MANAGEMENT,
  FEATURE_FLAGS.CAPTAIN_ADVANCED_APPROVALS,
];

export const CAPTAIN_CUSTOM_TOOLS_FEATURE_FLAGS = [
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CAPTAIN_ADVANCED_MANAGEMENT,
];

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.HELP_CENTER,
];
